"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldKeyByValue = exports.getKeyByValue = exports.NO_DEEP_TRANSFORM_KEYS = exports.EXCLUDE_TRANSFORM_KEYS = exports.FIELDS_FULL_NAME = void 0;
exports.FIELDS_FULL_NAME = {
    id: "appId",
    cnid: "countryId",
    ab: "appBrand",
    et: "eventType",
    si: "sessionId",
    ui: "userId",
    ajid: "adjustId",
    adid: "googleAdId",
    di: "deviceId",
    uuid: "deviceUuid",
    av: "appVersion",
    // view
    sn: "screenNum",
    sa: "screenAction",
    so: "screenOrder",
    sp: "screenParam",
    se: "screenExtra",
    srn: "screenReferrerNum",
    sr: "screenReferrer",
    sro: "screenReferrerOrder",
    du: "duration",
    // 点击
    co: "clickOrder",
    ct: "componentType",
    cid: "componentId",
    cn: "controlNum",
    bct: "businessClickType",
    bi: "businessInfo",
    // 曝光
    li: "listInfo",
    cnt: "exposeCount",
    eit: "elementInfoType",
    ei: "elementInfo",
    il: "inputList",
    ap: "absolutePosition",
    rp: "relativePosition",
    // 输入框
    ic: "inputContent",
    io: "inputOrder",
    oc: "onfocusCount",
    // 统计
    sl: "statisticsList",
    src: "successReportCount",
    set: "successEventType",
};
exports.EXCLUDE_TRANSFORM_KEYS = [
    "inputKey",
    "offset",
    "shouldDelete",
    "isComplete",
    "isException",
    "isUploading",
    "startTime",
];
exports.NO_DEEP_TRANSFORM_KEYS = ["extraInfo", "elementExtraInfo"];
function getKeyByValue(object, value) {
    return Object.keys(object).find(function (key) { return object[key] === value; });
}
exports.getKeyByValue = getKeyByValue;
function getFieldKeyByValue(value) {
    return getKeyByValue(exports.FIELDS_FULL_NAME, value);
}
exports.getFieldKeyByValue = getFieldKeyByValue;
